/* Klaviyo public client API. Never use a private API key in theme assets. */
(function (root) {
  const revision = '2026-07-15';
  function buildRequest({ siteId, email, variantId }) {
    siteId = String(siteId || '').trim();
    email = String(email || '').trim().toLowerCase();
    variantId = String(variantId || '').trim();
    if (!/^[a-zA-Z0-9]{6}$/.test(siteId)) throw new Error('Restock alerts are not connected yet. Please try again later.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw new Error('Please enter a valid email address.');
    if (!/^[1-9]\d*$/.test(variantId)) throw new Error('This product is not ready for restock alerts. Please try again later.');
    return {
      url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(siteId),
      options: {
        method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'revision': revision },
        body: JSON.stringify({ data: {
          type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
        } })
      }
    };
  }
  async function subscribe(input, fetchImpl = root.fetch.bind(root)) {
    const request = buildRequest(input);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetchImpl(request.url, { ...request.options, signal: controller.signal });
      if (response.status === 202) return; // Accepted with an empty response body.
      if (response.status === 429) throw new Error('Too many requests right now. Please wait a moment and try again.');
      if (response.status >= 500) throw new Error('Restock alerts are temporarily unavailable. Please try again later.');
      let data;
      try { data = await response.json(); } catch (_) {}
      if (data?.errors?.some(error => error.code === 'variant_not_found')) throw new Error('This product is not ready for restock alerts. Please try again later.');
      if (data?.errors?.some(error => error.source?.pointer?.includes('email'))) throw new Error('Please enter a valid email address.');
      throw new Error('Your signup could not be confirmed. Please try again later.');
    } catch (error) {
      if (error.name === 'AbortError' || error instanceof TypeError) throw new Error('We could not confirm your signup. Please check your connection and try again.');
      throw error;
    } finally { clearTimeout(timeout); }
  }
  const api = { buildRequest, subscribe, revision };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.PotionKlaviyoWaitlist = api;
})(typeof window === 'undefined' ? globalThis : window);
